import { AxiosError } from 'axios';
import { AppError } from '../types/Utility';

const isAppError = function <DataType>(error: unknown): error is AppError<DataType> {
    return error instanceof Error && (error instanceof AxiosError || 'response' in error);
};

export default isAppError;
